import { useEffect } from "react";
import { ListagemBibliotecas } from "src/components/bibliotecas/Listagem";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Bibliotecas"

const Bibliotecas = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])


  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ListagemBibliotecas />
        </div>
      </div>
    </div>
  );
};

export { Bibliotecas };